module.exports = __webpack_public_path__ + "img/ac1.0c2ab7a2.png";